export default (value) => {
  if (typeof value === 'string')
    return value === 'true'
  return !!value
}